module.exports = __webpack_public_path__ + "static/content_5_1_eg-0c4635166e28f07612561ebdd74d4da0.png";